import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum ReservationAdvancePaymentTypeId {
  ON_CREATION = 'on_creation',
  BEFORE_ARRIVAL = 'before_arrival',
}

export class ReservationAdvancePaymentType extends Codebook<ReservationAdvancePaymentTypeId> {
  static readonly ON_CREATION = new ReservationAdvancePaymentType(
    ReservationAdvancePaymentTypeId.ON_CREATION,
    () => $t('From reservation creation'),
  )
  static readonly BEFORE_ARRIVAL = new ReservationAdvancePaymentType(
    ReservationAdvancePaymentTypeId.BEFORE_ARRIVAL,
    () => $t('Before arrival'),
  )

  private constructor(
    public readonly id: ReservationAdvancePaymentTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
